import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BE_API_URL } from '../constants/app.constants';

@Injectable({
  providedIn: 'root',
})
export class KBService {
  private articlesCache: any[] | null = null;

  constructor(private http: HttpClient) {}

  getArticles(): Observable<any> {
    const url = `${BE_API_URL}/kb`;
    return this.http.get<any>(url);
  }
  getArticlesCached(): Observable<any[]> {
    if (this.articlesCache) {
      return of(this.articlesCache);
    }
    return this.getArticles().pipe(
      map((articles: any[]) => {
        this.articlesCache = articles;
        return articles;
      })
    );
  }
  getGroupedArticles(): Observable<any> {
    return this.http.get(`${BE_API_URL}/kb/grouped`);
  }
  askAI(questionOrPayload: string | any, language?: string): Observable<any> {
    const payload = typeof questionOrPayload === 'string'
        ? { question: questionOrPayload, language }
        : questionOrPayload;

    return this.http.post(`${BE_API_URL}/kb/ask`, payload);
  }
  sendFeedback(data: any): Observable<any> {
    return this.http.post(`${BE_API_URL}/kb/feedback`, data);
  }
}
